export const content = {
    name: 'Team and Advisors',
    description: `You're experts at building your 
                    business - let us handle the 
                    back-office complexities
    `,
};